export default __webpack_public_path__ + "static/media/logo-black.970cab63.png";